<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 text-lg-start text-center">
          <div class="font-14">
            Copyright (c) {{ this.currentYear }}, Youhonk. All rights reserved.
          </div>
        </div>
        <div class="col-lg-6 text-lg-end text-center">
          <a   href="javascript:void(0)" class="text-brand me-3"   v-on:click="this.$router.push('/privacy-policy')"> Privacy Policy </a>
          <a href="javascript:void(0)" class="text-brand"   v-on:click="this.$router.push('/terms-condition')"> Terms of Service </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterView",
  methods: {},
  data() {
  return {
    currentYear: new Date().getFullYear()
  }}
};
</script>
